import { Navigate, Outlet } from "react-router";
import { useAuth } from "@/lib/auth-context";

export function RequireAdmin() {
  const { isAdmin } = useAuth();

  if (!isAdmin) {
    return <Navigate to="/stocks" replace />;
  }

  return <Outlet />;
}
